import './stylesheet/themes.scss';
import "bootstrap/dist/css/bootstrap.min.css";
import "@vueform/multiselect/themes/default.css";

import './stylesheet/main.css'

import 'material-icons/iconfont/filled.css';
import 'material-icons/iconfont/round.css';
import '@night-owl-elite/vue-select/style.css';
import '@vuepic/vue-datepicker/dist/main.css';

import { createApp } from 'vue'
 import App from './App.vue'
import plugins from '@/plugins'
import icons from "@/plugins/font-awesome-icons.js";
icons();
const app = createApp(App)
app.use(plugins)


app.mount('#app')
